import { ADMIN_API_URL } from '../constants';

/**
 * Partner Service - API calls for Partner Dashboard
 * Handles all partner-related API interactions
 */

/**
 * Get authentication token from session storage
 */
const getAuthToken = () => {
    return sessionStorage.getItem('authToken');
};

/**
 * Common fetch wrapper with error handling
 */
const fetchWithAuth = async (url, options = {}) => {
    const token = getAuthToken();
    if (!token) {
        throw new Error('Authentication token not found');
    }

    const response = await fetch(url, {
        ...options,
        headers: {
            ...options.headers,
            'Authorization': `${token}`,
            'Content-Type': 'application/json',
        },
    });

    if (!response.ok) {
        const errorData = await response.json();

        // Check if error is token expiration
        if (errorData.message &&
            (errorData.message.name === "TokenExpiredError" ||
                errorData.message.message === "jwt expired")) {
            const error = new Error('jwt expired');
            error.message = errorData.message;
            error.name = "TokenExpiredError";
            throw error;
        }

        throw new Error(errorData.message || 'API request failed');
    }

    return response.json();
};

const partnerService = {
    /**
     * Get partner applications with filters and pagination
     * @param {Object} params - Query parameters
     * @returns {Promise<Object>} Applications data with pagination
     */
    getApplications: async (params = {}) => {
        const queryParams = new URLSearchParams();

        if (params.page) queryParams.append('page', params.page);
        if (params.limit) queryParams.append('limit', params.limit);
        if (params.startDate) queryParams.append('startDate', params.startDate);
        if (params.endDate) queryParams.append('endDate', params.endDate);
        if (params.status) queryParams.append('status', params.status);
        if (params.mobile) queryParams.append('mobile', params.mobile);
        if (params.applicationId) queryParams.append('applicationId', params.applicationId);

        const response = await fetchWithAuth(
            `${ADMIN_API_URL}partner/applications?${queryParams}`,
            { method: 'GET' }
        );

        return response;
    }
};

export default partnerService;
